export const types = {
  LOGIN: {
    STARTED: 'LOGIN_STARTED',
    SUCCESS: 'LOGIN_SUCCESS',
    FAILURE: 'LOGIN_FAILURE',
  },
  LOGOUT: 'AUTH.LOGOUT.REQUEST',
  CLEAN_USER_CREDENTIALS: 'AUTH.CLEAN_USER_CREDENTIALS',
  UPDATE_USER_INFO: 'UPDATE_USER_INFO',
  UPDATE_PERMISSION: 'AUTH.UPDATE_PERMISSION',
  RESET_PASSWORD: {
    REQUEST: 'AUTH.RESET_PASSWORD_REQUEST',
    RESPONSE: 'AUTH.RESET_PASSWORD_RESPONSE',
  },
  REQUEST_FOR_RESET_PASSWORD_BY_EMAIL: {
    STARTED: 'AUTH.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL_STARTED',
    SUCCESS: 'AUTH.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL_SUCCESS',
    FAILURE: 'AUTH.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL_FAILURE',
  },
  CHANGE_PASSWORD_BY_TOKEN: {
    STARTED: 'AUTH.CHANGE_PASSWORD_BY_TOKEN_STARTED',
    SUCCESS: 'AUTH.CHANGE_PASSWORD_BY_TOKEN_SUCCESS',
    FAILURE: 'AUTH.CHANGE_PASSWORD_BY_TOKEN_FAILURE',
  },
  RESET_FORGOT_PASSWORD_FORM: 'RESET_FORGOT_PASSWORD_FORM',
  LOGIN_WITH_TOKEN: 'LOGIN_WITH_TOKEN',
  SET: {
    USER_TOKEN: 'SET_USER_TOKEN',
  },
  CONFIRM_OTP: 'CONFIRM_OTP',
  REQUEST_NEW_OTP: 'REQUEST_NEW_OTP',
  BLOCK_TWO_FACTOR_AUTH_FORM: 'BLOCK_TWO_FACTOR_AUTH_FORM',
  UNBLOCK_TWO_FACTOR_AUTH_FORM: 'UNBLOCK_TWO_FACTOR_AUTH_FORM',
  ATTEMPTS_COUNT_EXHAUSTED: 'ATTEMPTS_COUNT_EXHAUSTED',
};

export const login = (email, password) => ({
  type: types.LOGIN.STARTED,
  email,
  password,
});

export const loginSuccess = (userId, token) => ({
  type: types.LOGIN.SUCCESS,
  userId,
  token,
});

export const loginFailure = () => ({
  type: types.LOGIN.FAILURE,
});

export const logout = () => ({ type: types.LOGOUT });

export const cleanUserCredentials = () => ({ type: types.CLEAN_USER_CREDENTIALS });

export const updateUserInfo = ({ email, username }) => ({
  type: types.UPDATE_USER_INFO,
  email,
  username,
});

export const updatePermission = (permission) => ({
  type: types.UPDATE_PERMISSION,
  permission,
});

export const resetPassword = (newPassword, userId) => ({
  type: types.RESET_PASSWORD.REQUEST,
  newPassword,
  userId,
});

export const resetPasswordResponse = (error) => ({
  type: types.RESET_PASSWORD.RESPONSE,
  error,
});

export const requestForResetPasswordByEmail = (email) => ({
  type: types.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL.STARTED,
  email,
});

export const requestForResetPasswordByEmailSuccess = () => ({
  type: types.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL.SUCCESS,
});

export const requestForResetPasswordByEmailFailure = () => ({
  type: types.REQUEST_FOR_RESET_PASSWORD_BY_EMAIL.FAILURE,
});

export const changePasswordByToken = (userId, newPassword, token) => ({
  type: types.CHANGE_PASSWORD_BY_TOKEN.STARTED,
  userId,
  newPassword,
  token,
});

export const changePasswordByTokenSuccess = () => ({
  type: types.CHANGE_PASSWORD_BY_TOKEN.SUCCESS,
});

export const changePasswordByTokenFailure = () => ({
  type: types.CHANGE_PASSWORD_BY_TOKEN.FAILURE,
});

export const resetForgotPasswordForm = () => ({
  type: types.RESET_FORGOT_PASSWORD_FORM,
});

export const loginWithToken = ({ userId, token }) => ({
  type: types.LOGIN_WITH_TOKEN,
  userId,
  token,
});

export const setUserToken = ({ userId, token }) => ({
  type: types.SET.USER_TOKEN,
  userId,
  token,
});

export const confirmOTP = (payload) => ({
  type: types.CONFIRM_OTP,
  payload,
});

export const requestNewOTP = (payload) => ({
  type: types.REQUEST_NEW_OTP,
  payload,
});

export const blockTwoFactorAuthForm = () => ({
  type: types.BLOCK_TWO_FACTOR_AUTH_FORM,
});

export const unblockTwoFactorAuthForm = () => ({
  type: types.UNBLOCK_TWO_FACTOR_AUTH_FORM,
});

export const attemptsCountExhausted = () => ({
  type: types.ATTEMPTS_COUNT_EXHAUSTED,
});



// WEBPACK FOOTER //
// ./redux/actions/authentication.js